import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './CreateStaff.module.css';

function CreateStaff() {
    const [file, setFile] = useState();
    const [name, setName] = useState('');
    const [position, setPosition] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('none');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (subject === 'none') {
            setError('กรุณาเลือกกลุ่มสาระ');
            return;
        }

        if (!name.trim()) {
            setError('กรุณากรอกชื่อ-สกุล');
            return;
        }

        const formdata = new FormData();
        formdata.append('file', file);
        formdata.append('name', name);
        formdata.append('position', position);
        formdata.append('email', email);
        formdata.append('subject', subject);

        try {
            await axios.post('https://school-web-server-eight.vercel.app/createStaff', formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            navigate('/login/managestaff');
        } catch (err) {
            console.error('Can\'t create staff:', err);
        }
    };

    return (
        <div className={styles.createStaffContainer}>
            <div className={styles.createContent}>
                <form onSubmit={handleSubmit}>
                    <h2>เพิ่มบุคลากร</h2>
                    <div className={styles.subject}>
                        <label htmlFor="subject">กลุ่มสาระ</label>
                        <select
                            className={styles.createFormSubject}
                            value={subject}
                            onChange={(e) => {
                                setSubject(e.target.value);
                                setError('');
                            }}
                            required
                        >
                            <option value="none" disabled>เลือกกลุ่มสาระ</option>
                            <option value="social">สังคมศึกษาฯ</option>
                            <option value="languages">ภาษาต่างประเทศ</option>
                            <option value="physicaledu">พลศึกษาฯ</option>
                            <option value="homeeconomic">การงานอาชีพ</option>
                            <option value="art">ศิลปะ</option>
                            <option value="science">วิทยาศาสตร์</option>
                            <option value="thai">ภาษาไทย</option>
                            <option value="math">คณิตศาสตร์</option>
                        </select>
                        {error && <p className={styles.textDanger}>{error}</p>}
                    </div>
                    <div className={styles.formInput}>
                        <label htmlFor="image">รูปภาพ</label>
                        <input
                            type="file"
                            className={styles.createForm}
                            onChange={e => setFile(e.target.files[0])} />
                    </div>
                    <div className={styles.formInput}>
                        <label htmlFor="name">ชื่อ-สกุล</label>
                        <input
                            type="text"
                            placeholder='กรอกชื่อ-สกุล'
                            className={styles.createForm}
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                setError('');
                                e.target.setCustomValidity('');
                            }}
                            onInvalid={(e) => e.target.setCustomValidity('กรุณากรอกชื่อ-สกุล')}
                            required
                        />
                    </div>
                    <div className={styles.formInput}>
                        <label htmlFor="position">ตำแหน่ง</label>
                        <input
                            type="text"
                            placeholder='กรอกตำแหน่ง'
                            className={styles.createForm}
                            value={position}
                            onChange={(e) => setPosition(e.target.value)}
                        />
                    </div>
                    <div className={styles.formInput}>
                        <label htmlFor="email">อีเมล์</label>
                        <input
                            type="email"
                            placeholder='กรอกอีเมล์'
                            className={styles.createForm}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <button className={styles.addStaffBt}>เพิ่มข้อมูล</button>
                    <button type="button" className={styles.deleteBtn} onClick={() => navigate('/login/managestaff')}>กลับหน้าหลัก</button>
                </form>
            </div>
        </div>
    );
}

export default CreateStaff;
